module.exports = __webpack_public_path__ + "assets/img/yzzx_anru.e66daf8d.png";